var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { useContext } from 'react';
import { translate } from '../../../../strings/i18n';
import Icon from '../../../icon';
import { manageProfileLinkDataProps } from '../../../../const/analytics';
import { IconWrapper, Wrapper } from '../subcomponents';
import { AddressChangeTextWrapper, InfoIconWrapper, ManageProfileLink, TextWrapper } from './subcomponents';
import CBRContext from '../../context';
var AddressChangeInfo = function () {
    var _a = useContext(CBRContext), handleProfileClick = _a.handleProfileClick, accountId = _a.accountId;
    var manageProfileLinkText = translate('button.manageProfile');
    var handleProfileLinkClick = function () {
        /* istanbul ignore else -- @preserve */
        if (handleProfileClick) {
            handleProfileClick(accountId);
        }
    };
    var manageProfileLink = (_jsx(ManageProfileLink, __assign({ buttonType: "text", onClick: handleProfileLinkClick }, manageProfileLinkDataProps, { children: manageProfileLinkText })));
    return (_jsxs(Wrapper, { children: [_jsx(InfoIconWrapper, { children: _jsx(IconWrapper, { children: _jsx(Icon, { icon: faCircleInfo, title: "address-change-info", size: "lg" }) }) }), _jsx(TextWrapper, { children: _jsx(AddressChangeTextWrapper, { children: _jsx(Trans, __assign({ i18nKey: "wrongAddress", value: manageProfileLink, components: { manageProfileLink: manageProfileLink } }, { children: translate('text.wrongAddress', { manageProfileLinkText: manageProfileLinkText }) })) }) })] }));
};
export default AddressChangeInfo;
